export default {
    "fr": {
        "How to book?": "Comment faire une réservation ?"
    },
    "en": {
        "How to book?": "How to book?"
    }
}
